import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard to="/support/integration-definition" image="/static/img/Documentation.png" imageAlt="Picture of documents" description="What is an Integration?">
    Find out how Skyward defines an Integration
  </FeatureCard>
);
